// extracted by mini-css-extract-plugin
export default {"outerWrapper":"DetailsPaneTable_outerWrapper__LPktV","container":"DetailsPaneTable_container__tUjJC"};